<template>
  <AppRow>
    <AppAlert type="success" class="mb-5">
      {{ $tt('payment_step.tbank_note') }}
    </AppAlert>
    <PayButton :price="total" :loading="pending" @click="goPay" />
  </AppRow>
</template>

<script setup lang="ts">
import { getTbankPaymentUrl } from '~/helpers/http';
import { calcTotalPrice } from '~/helpers/price';
import type { VisaForm } from '~/types';

const props = defineProps<{
  form: VisaForm;
}>();

const { currency } = useBranch();
const total = computed(() => calcTotalPrice(props.form, currency));

const { pending, data, error } = await useAsyncData('tbankPaymentUrl', () => {
  return getTbankPaymentUrl({
    form: props.form,
    successQueryParams: useRoute().query as Record<string, string>
  });
});

if (error.value) {
  throw new Error('Failed to fetch Tbank payment URL');
}

function goPay() {
  window.location.href = data.value!.url;
}
</script>

<style scoped>
.note {
  width: 80%;
}
</style>